import { useVariant } from "../../context/VariantContext";
import { PRESS } from "../../data/content";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./About";

export const Press = () => {
  const { variant } = useVariant();
  const loop = [...PRESS, ...PRESS];
  return (
    <section
      id="press"
      data-testid="press"
      className="relative overflow-hidden border-t px-0 py-24 lg:py-32"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto mb-14 max-w-7xl px-6 lg:px-10">
        <Reveal>
          <SectionEyebrow index="05">Recognition</SectionEyebrow>
          <h2 className="font-head mt-6 max-w-2xl text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
            Featured across the world's leading press.
          </h2>
        </Reveal>
      </div>

      <div className="gw-marquee relative w-full">
        <div className="gw-marquee-track">
          {loop.map((name, i) => (
            <span
              key={i}
              className={`mx-10 shrink-0 whitespace-nowrap text-2xl text-[color:var(--text-2)] opacity-60 transition-opacity hover:opacity-100 sm:text-3xl ${
                variant === "swiss"
                  ? "font-accent uppercase tracking-tight"
                  : "font-head uppercase tracking-[0.18em]"
              }`}
              style={{ color: "var(--text)" }}
            >
              {name}
            </span>
          ))}
        </div>
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 left-0 w-24"
          style={{ background: "linear-gradient(90deg, var(--bg), transparent)" }}
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 right-0 w-24"
          style={{ background: "linear-gradient(270deg, var(--bg), transparent)" }}
        />
      </div>
    </section>
  );
};
